import { render, staticRenderFns } from "./MainEventCard.vue?vue&type=template&id=c7c9d04a&scoped=true"
import script from "./MainEventCard.vue?vue&type=script&lang=js"
export * from "./MainEventCard.vue?vue&type=script&lang=js"
import style0 from "./MainEventCard.vue?vue&type=style&index=0&id=c7c9d04a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c9d04a",
  null
  
)

export default component.exports